import {Component} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Observable} from "rxjs/Observable";
import "rxjs/add/observable/fromPromise";
import {NotificationsService} from "../../../../services/notifications.service";
import {Reservation, ReservationsService} from "../../../../services/reservations.service";

@Component({
  selector: 'reject-reservation-modal',
  templateUrl: 'reject-reservation-modal.component.html'
})

export class RejectReservationModalComponent {
  reservation: Reservation;

  static open(modalService: NgbModal, reservation: Reservation): Observable<boolean> {
    const modalRef = modalService.open(RejectReservationModalComponent);
    modalRef.componentInstance.reservation = reservation;
    return Observable.fromPromise(modalRef.result)
  }

  constructor(private activeModal: NgbActiveModal, private reservationService: ReservationsService, private notificationsService: NotificationsService) {
  }

  close() {
    this.activeModal.close(false);
  }

  confirm() {
    this.reservationService
      .rejectReservation(this.reservation.id)
      .subscribe(_ => {
        this.notificationsService.show('Rezerwacja została odrzucona.')
        this.activeModal.close(true);
      })
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/components/home/reservations-list/modals/reject-reservation-modal.component.ts